import { DictionaryDto } from '@hub/generated/models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterCollection, FilterValue, FilterValueCollection, FilterSingleSelectSearch } from '@hub/generated/models';
import { SearchController } from '@hub/generated/services';

@Component({
    selector: 'f-filterSingleSelectSearch',
    templateUrl: './filterSingleSelectSearch.component.html',
    styleUrls: ['./filterSingleSelectSearch.component.scss']
})
export class FilterSingleSelectSearchComponent implements OnInit {
    // Constructors
    constructor(private controller: SearchController) {
    }

    // Properties
    @Input()
    public filter: FilterSingleSelectSearch;

    private _filterCollection: FilterCollection;

    @Input()  set filterCollection(f: FilterCollection) {
        this._filterCollection = f;
        this.value = this.getValue();
    }
    get filterCollection() {
        return this._filterCollection;
    }

    @Input()
    public inline: boolean = false;

    @Output()
    public ondataChange: EventEmitter<FilterValueCollection> = new EventEmitter<FilterValueCollection>();

    public value: DictionaryDto;
    public columnName: string;
    public suggestions: DictionaryDto[];

    public ngOnInit() {
        this.columnName = this.filter.ColumnName;
        this.value = this.getValue();
    }

    search(event) {
        this.controller.SearchTitles({ Types: this.filter.Types, Search: event.query }).subscribe(data => {
            this.suggestions = data;
        });
    }

    public onChange() {
        let result: FilterValueCollection = new FilterValueCollection();

        result.ColumnName = this.columnName;
        if (this.value) {
            let value: FilterValue = { Key: this.value.Id, Value: this.value.Value, EntityType: null };
            result.List = [value];
        } else
            result.List = [];
        this.ondataChange.emit(result);
    }

    public onClear() {
        let result: FilterValueCollection = new FilterValueCollection();

        result.ColumnName = this.columnName;
        result.List = undefined;
        this.ondataChange.emit(result);
    }

    private getValue(): DictionaryDto {
        if (!!this.filterCollection && !!this.filterCollection.List) {
            let values = this.filterCollection.List.filter((item) => item.ColumnName == this.columnName)[0];
            if (!!values && !!values.List && !!values.List.length) {
                let value = values.List[0]

                return { Id: value.Key, Value: value.Value };
            }
        }

        return null;
    }
}
